import React, { FC, SVGProps } from 'react'
import s from './MapButtonActionForAside.module.sass'
import IconArrowHideColumn from '@icons/icon-arrow-small.svg'

interface Props {
  className?: string
}

const MapButtonActionForAside: FC<
  Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = ({ className = '', ...props }) => {
  return (
    <button className={`${s.close} ${className}`} {...props}>
      <IconArrowHideColumn />
    </button>
  )
}

export default MapButtonActionForAside
